/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { isEmpty, cloneDeep, set } from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { currencyCodes, inconterms, checkArray } from '../../../../Components/helper';
import * as action from '../Store/PurchaseOrder.action';
import * as configAction from '../../Bom/store/BOMConfig.action';
import * as supplierAction from '../../../Supplier/store/Supplier.action';
import * as colourAction from '../../../Library/ColorLibary/store/ColorLibrary.action';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import useGrandTotal from '../Hooks/useGrandTotal';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';

export const StateContext = createContext(null);

export default function PurchaseOrderStateProvider({ children, fromPreview, isPublicPoPage }) {
  const { devOrderId, poCreatedId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation('common');
  const {
    UserDetails: { userInfo, isSupplierLoggedIn },
    purchaseOrderData: { purchaseOrderDetails, supplierList, previewData, devorderData, colourWayList },
    BOMConfigDetails: { isProductArchived },
    SuppliersDetails: { allTierList },
    ColorLibraryDetails: { ColorLibList },
    Users: { logInRights },
  } = useSelector((reduxState) => reduxState);

  const { CheckActionPermission } = useComponent();
  const poAddEditAccess = CheckActionPermission(logInRights, 'products', 'purchaseOrder', 'addEdit');
  const poDeleteAccess = CheckActionPermission(logInRights, 'products', 'purchaseOrder', 'delete');
  const [lengthEnabled, setLengthEnabled] = useState(true);
  const oldInitialSetting = {
    templateJsonSchema: [],
    poTemplateId: '',
    poTemplateName: '',
    colourLibraries: [],
    colourNames: '',
    selectedTemplate: null,
    selectedSupplier: null,
    selectedCurrency: null,
    shipMethod: null,
    visible: null,
  };

  const initialSetting = {
    selectedColours: [],
    selectedSupplier: null,
    selectedTemplate: null,
    selectedCurrency: null,
    currOptions: [],
    selectedApproveByDate: null,
    selectedActualApproveByDate: null,
    incotermsArr: inconterms?.map((inco) => {
      return { value: inco, label: inco };
    }),
    loader: true,
    portOfLading: '',
    costIncluded: 'Yes',
    newColourOptions: [],
  };

  const searchParams = new URLSearchParams(location?.search);
  const locaStates = location?.state;
  const stateDuplication = searchParams.get('forDuplication');
  const dId = searchParams.get('dId');
  const pId = searchParams.get('pId');
  const forDuplication = locaStates?.forDuplication || Boolean(stateDuplication);

  const modalInitialStates = {
    poFilesModalState: false,
    confirmModalType: null,
    confirmModalState: false,
    confirmModalMessage: '',
    confirmModalSecondMessage: '',
    confirmModalThirdMessage: '',
    confirmModalShowthirdMsg: false,
    confirmModalTitle: '',
    confirmModalCommentState: false,
    confirmModalCommentMsg: '',
    confirmModalLoading: false,
  };
  const { calculateGrandTotal } = useGrandTotal();
  const [newTemplate, setNewTemplate] = useState([]);
  const [oldStatedata, setOldState] = useState(oldInitialSetting);
  const [purchaseOrderState, setPurchaseOrderState] = useState(initialSetting);
  const [controlState, setControlState] = useState(modalInitialStates);

  useEffect(() => {
    return () => {
      setOldState(oldInitialSetting);
      setPurchaseOrderState(initialSetting);
      setControlState(modalInitialStates);
    };
  }, []);

  const setSupplierNull = () => {
    set(purchaseOrderState, 'supplierId', '');
    set(purchaseOrderState, 'supplierName', '');
    return null;
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (userData?.lengthVisible !== null && userData?.lengthVisible !== undefined) {
      setLengthEnabled(userData?.lengthVisible);
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(colourWayList)) {
      const options = colourWayList?.map((ele) => {
        return {
          ...ele,
          label: `${ele.name} | ${ele.newReferences}`,
          value: ele?._id,
        };
      });
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        newColourOptions: options,
      }));
    }
  }, [colourWayList]);

  const forPpsDates = (obj) => {
    return obj?.ppsApprovedDate ? moment(new Date(obj?.ppsApprovedDate)).format('DD-MMM-YYYY') : null;
  };

  const supplierAddress = (suppler) => {
    const array = [];
    if (suppler?.streetAddress) {
      array.push(suppler?.streetAddress);
    }
    if (suppler?.townCity) {
      array.push(suppler?.townCity);
    }
    if (suppler?.zipCode) {
      array.push(suppler?.zipCode);
    }
    if (suppler?.buildingNo) {
      array.push(suppler?.buildingNo);
    }
    if (suppler?.country) {
      array.push(suppler?.country);
    }
    return array;
  };

  const forDropDown = (columnElement) => {
    return columnElement?.key === 'Dropdown'
      ? {
          status: true,
          errorMsg: 'Please select an option',
        }
      : {
          status: true,
          errorMsg: 'Input value is required',
        };
  };
  const timePicker = (columnElement) => {
    return columnElement?.key === 'Time_Picker'
      ? {
          status: true,
          errorMsg: 'Time Selection is required',
        }
      : forDropDown(columnElement);
  };

  const otherOptions = (columnElement) => {
    return columnElement?.key === 'Date_Picker'
      ? {
          status: true,
          errorMsg: 'Date Selection is required',
        }
      : timePicker(columnElement);
  };

  const conditonsForTermAndConditions = (element) => {
    element.columns.forEach((column) => {
      column.forEach((columnElement) => {
        if (columnElement?.required && columnElement?.enable) {
          if (
            columnElement?.key === 'Text_Area' ||
            columnElement?.key === 'Text' ||
            columnElement?.key === 'Ratio_Button' ||
            columnElement?.key === 'Date_Picker' ||
            columnElement?.key === 'Dropdown' ||
            columnElement?.key === 'Time_Picker'
          ) {
            if (!columnElement?.value) {
              columnElement.hasError =
                columnElement?.key === 'Ratio_Button'
                  ? {
                      status: true,
                      errorMsg: 'selection is required',
                    }
                  : otherOptions(columnElement);
            }
          } else {
            columnElement.options.forEach((optionElement) => {
              if (!optionElement.value) {
                columnElement.hasError = {
                  status: true,
                  errorMsg: 'Please select a Checkbox',
                };
              }
            });
          }
        }
      });
    });
  };

  const handleTempletJsonRequiredField = (name, element) => {
    if (name === 'Terms_conditions' || name === 'A_F_Details' || name === 'Company_Details' || name === 'Section') {
      conditonsForTermAndConditions(element);
    }
  };

  const checkValidation = () => {
    purchaseOrderState?.templateJsonSchema?.forEach((element) => {
      handleTempletJsonRequiredField(element?.key, element);
    });
    setPurchaseOrderState((prevState) => ({
      ...prevState,
      ...purchaseOrderState,
    }));
  };

  const manipulateEditPage = async (obj) => {
    const currentSupplier =
      fromPreview || isPublicPoPage
        ? [...allTierList, ...supplierList]?.find((val) => val?.name?.trim() === obj?.supplier?.trim())
        : [...allTierList, ...supplierList]?.find((val) => val._id === obj?.supplierId);

    const createdBy = fromPreview || isPublicPoPage ? obj?.createdBy : purchaseOrderDetails?.createdBy;

    obj?.templateJsonSchema?.forEach((tempJson) => {
      if (tempJson.key === 'A_F_Details') {
        tempJson.columns = tempJson?.columns?.map((columns) => {
          columns = columns.map((column) => {
            switch (column?.id) {
              case '1':
                column.value = column?.value || currentSupplier?.name || '';
                break;
              case '2':
                column.value = column?.value || supplierAddress(currentSupplier?.companies).join('\n') || '';
                break;
              case '3':
                const val = currentSupplier?.companies?.code || '';
                column.value = column?.value || val || '';
                break;
              case '4':
                column.options = column?.options && column.options.length > 0 ? column.options : currentSupplier?.supplierUser || [];
                column.value = column?.value || '';
                break;
              case '6':
                column.options = column?.options && column.options.length > 0 ? column.options : currentSupplier?.factories || [];
                column.value = column?.value || '';
                break;
              default:
                column.value = column?.value || '';
                break;
            }
            return column;
          });

          return columns;
        });
      }
      if (tempJson.key === 'Company_Details') {
        tempJson.columns = tempJson?.columns?.map((columns) => {
          columns = columns?.map((column) => {
            switch (column?.uniqueId) {
              case '0':
                column.options =
                  column?.options && column.options.length > 0
                    ? column.options
                    : devorderData?.contactPersonList
                    ? [...(devorderData?.contactPersonList?.filter((e) => e?.accountVerified) || [])]
                    : [];
                column.value = column?.value || '';
                break;
              case '1':
                column.value = column?.value || (createdBy ? `${createdBy?.firstName}  ${createdBy?.lastName}` : '');
                break;
              case '4':
                column.value = column?.value || createdBy?.email || '';
                break;
              default:
                column.value = column?.value || '';
                break;
            }
            return column;
          });

          return columns;
        });
      }
      if (tempJson.key === 'Shipping_Details') {
        tempJson.columns?.map((colEle) => {
          return colEle?.filter((columColEle) => {
            return columColEle?.id !== '14';
          });
        });
        tempJson.columns = tempJson?.columns?.map((columns) => {
          columns = columns?.map((column) => {
            switch (column?.uniqueId) {
              case '1':
                column.value = column?.value || (obj.shipMethod?.label ? { name: obj.shipMethod.label } : '');
                break;
              case '12':
                column.value = column?.value || obj.costIncluded || '';
                break;
              case '3':
                column.value = column?.value || obj.portOfLanding || '';
                break;
              case '5':
                column.value = column?.value || (obj.incoterms?.label ? { name: obj.incoterms.label } : '');
                break;
              case '13':
                column.value = column?.value || obj.shippingCost || '';
                break;
              case '7':
                column.value = column?.value || obj.portOfLading || '';
                break;
              default:
                column.value = column?.value || '';
                break;
            }
            return column;
          });

          return columns;
        });
      }
      if (tempJson.key === 'Ratio_Pack' && checkArray(obj?.colourLibraries)) {
        const hasColourValue = obj?.colourLibraries.filter((e) => e);
        for (const [element, index] of hasColourValue) {
          for (const ele of ColorLibList) {
            if (ele?._id === element) {
              const ratioArray = obj?.templateJsonSchema?.filter((ratioEle) => ratioEle.type === 'Ratio_Pack');
              const foundValue = ratioArray.filter((schemaEle) => schemaEle.colorWay?._id === element);
              if (ratioArray.length > obj?.colourLibraries?.length) {
                const newTempjson = [];
                for (const ratEle of ratioArray) {
                  if (ratEle.colorWay?._id === element) {
                    newTempjson.push(ratEle);
                  }
                }
                const i = obj?.templateJsonSchema.findIndex((ctEle) => ctEle.type === 'Ratio_Pack');
                obj?.templateJsonSchema?.splice(i, ratioArray.length);
                obj?.templateJsonSchema?.splice(i + 1, 0, newTempjson[0]);
              }
              if (isEmpty(foundValue)) {
                obj?.templateJsonSchema.splice(index + 1, 0, {
                  colorWay: ele,
                  id: '6',
                  key: 'Ratio_Pack',
                  label: 'Ratio Packs',
                  materialCompositions: [{}],
                  multiplePacks: [{ multiplePackedRows: [{}] }],
                  multipleTotalPacks: [{ multipleTotalPackedRows: [{}] }],
                  ratioPacks: [{ leftColumn: [{}], rigthColumn: [{}] }],
                  sigularPackedUnits: [{ singularPackedRows: [{}] }],
                  type: 'Ratio_Pack',
                });
              }
            }
          }
        }
      }
      return tempJson;
    });
    return obj;
  };

  useEffect(() => {
    const callFn = async () => {
      try {
        const object = {
          InActive: 'Draft',
          canceled: 'Cancelled',
          revised: 'Revised',
          Approve: 'Confirmed',
          Reject: 'Rejected',
          Delivered: 'Delivered',
          Active: 'Active',
          'Cancel Request': 'Cancel Request',
        };

        const supplier = [...allTierList, ...supplierList].find((ele) => ele._id === purchaseOrderDetails.supplierId);
        const obj = {
          ...purchaseOrderDetails,
          shipMethod: {
            value: purchaseOrderDetails?.shipMethod,
            label: purchaseOrderDetails?.shipMethod,
          },
          incoterms: {
            value: purchaseOrderDetails?.incoterms,
            label: purchaseOrderDetails?.incoterms,
          },
          selectedCurrency: {
            value: purchaseOrderDetails?.currency,
            label: purchaseOrderDetails?.currency,
          },
          selectedTemplate: {
            value: purchaseOrderDetails?.poTemplateName,
            label: purchaseOrderDetails?.poTemplateName,
          },
          selectedSupplier: supplier
            ? {
                value: supplier?._id,
                label: supplier?.name,
              }
            : setSupplierNull(),
          poSelectedDate: purchaseOrderDetails?.poSelectedDate ? new Date(purchaseOrderDetails?.poSelectedDate) : forPpsDates(purchaseOrderDetails),
          selectedColours: purchaseOrderDetails?.colourLibraries,
          status: object[purchaseOrderDetails?.status] || '',
          loader: false,
        };
        const newObj = { ...(await manipulateEditPage(obj)) };
        const newState = { ...purchaseOrderState, ...newObj };
        const obj2 = cloneDeep(await calculateGrandTotal(newState));
        setPurchaseOrderState((prevState) => ({
          ...prevState,
          ...obj2,
        }));
      } catch (error) {
        console.error('Error in callFn:', error);
        // Ensure loader is turned off even if there's an error
        setPurchaseOrderState((prevState) => ({
          ...prevState,
          loader: false,
        }));
      }
    };

    const callPreviewFromDetailsFn = async () => {
      // In preview mode, use purchaseOrderDetails as-is without manipulation to preserve API values
      const obj2 = cloneDeep(await calculateGrandTotal(purchaseOrderDetails));
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        ...purchaseOrderDetails,
        poOrderNo: purchaseOrderDetails?.poOrderNo,
        ...obj2,
        loader: false,
      }));
    };

    const callPreviewFn = async () => {
      // Handle case where previewData might be just templateJsonSchema array or full PO object
      const isTemplateArray = Array.isArray(previewData);
      const templateData = isTemplateArray ? { templateJsonSchema: previewData } : previewData;

      // In preview mode, use the data as-is without manipulation to preserve API values
      const obj2 = cloneDeep(await calculateGrandTotal(templateData));
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        ...templateData,
        poOrderNo: templateData?.poOrderNo,
        ...obj2,
        loader: false,
      }));
    };

    if (purchaseOrderDetails !== null && purchaseOrderDetails !== undefined && !fromPreview && !isPublicPoPage) {
      callFn();
    } else if (purchaseOrderDetails !== null && purchaseOrderDetails !== undefined && fromPreview && !isPublicPoPage) {
      callPreviewFromDetailsFn();
    } else if (previewData && !isEmpty(previewData)) {
      callPreviewFn();
    } else if ((purchaseOrderDetails === null || purchaseOrderDetails === undefined) && !fromPreview && !isPublicPoPage) {
      // Handle case where API returned null/undefined - set loader to false
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        loader: false,
      }));
    }
  }, [purchaseOrderDetails, allTierList, fromPreview, previewData, newTemplate, isPublicPoPage]);

  useEffect(() => {
    const callFn = async () => {
      batch(async () => {
        await callDevorderApiFn();
      });
    };
    if ((!isEmpty(devOrderId) || !isEmpty(dId)) && !fromPreview && !isPublicPoPage) {
      callFn();
    }
  }, [dispatch, devOrderId, dId, fromPreview, isPublicPoPage]);

  useEffect(() => {
    const callFn = async () => {
      batch(async () => {
        await callDevorderPoidApiFn();
      });
    };
    if ((!isEmpty(devOrderId) || !isEmpty(dId)) && (!isEmpty(poCreatedId) || !isEmpty(pId)) && !fromPreview && !isPublicPoPage) {
      callFn();
    } else {
      const callDevApi = async () => {
        await dispatch(action.fetchDevorder(devOrderId || dId));
      };
      if (!isPublicPoPage) callDevApi();
    }
  }, [dispatch, devOrderId, dId, poCreatedId, pId, fromPreview, isPublicPoPage]);

  useEffect(() => {
    const callFn = () => {
      batch(async () => {
        await callUserIdBasedApiFn();
      });
    };
    if (!isEmpty(userInfo?.userId) && !fromPreview && !isPublicPoPage) {
      callFn();
    }
  }, [dispatch, userInfo?.userId, fromPreview, isPublicPoPage]);

  useEffect(() => {
    if (currencyCodes) {
      const manipulatedCurrency = currencyCodes?.map((code) => {
        return {
          value: code,
          label: code,
        };
      });
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        currOptions: manipulatedCurrency,
      }));
    }
  }, [currencyCodes]);

  const callDevorderApiFn = async () => {
    const obj = {
      devOrderId: devOrderId || dId,
      allDetails: true,
    };
    try {
      Promise.all([
        dispatch(action.fetchProfile()),
        dispatch(action.fetchDevorder(devOrderId || dId)),
        dispatch(action.fetchDevorderSupplier(obj)),
        dispatch(configAction.fetchProductDetails(devOrderId || dId)),
        dispatch(configAction.fetchTrafficLights(devOrderId || dId)),
        dispatch(action.createPoPermission({ devOrderId: devOrderId || dId })),
        dispatch(action.fetchTradeRef({ devOrderId: devOrderId || dId })),
        dispatch(supplierAction.fetchAllTierSupplierListAction()),
        dispatch(
          colourAction.fetchColorLibrary({
            loggedInUserId: userInfo?.userId,
          }),
        ),
      ]);
    } catch (err) {
      console.log(err, 'callDevOrderApiFn- PO');
    }
    setPurchaseOrderState((response) => ({
      ...response,
      loader: false,
    }));
  };

  const callDevorderPoidApiFn = async () => {
    const poIdValue = poCreatedId || pId;
    if (!poIdValue || (typeof poIdValue === 'string' && poIdValue.trim() === '')) {
      return;
    }
    const obj = {
      devOrderId: devOrderId || dId,
      poId: poIdValue,
      poOrderId: poIdValue,
    };
    Promise.all([dispatch(action.fetchPoTemplate({ poId: poIdValue })), dispatch(action.fethcPoDetails(obj))]);
  };

  const callUserIdBasedApiFn = async () => {
    Promise.all([
      dispatch(
        action.fetchMaterialPlacementComponent({
          loggedInUserId: userInfo?.userId,
        }),
      ),
      dispatch(action.fetchLegLengths({ loggedInUserId: userInfo?.userId })),
      dispatch(action.fetchSizes({ loggedInUserId: userInfo?.userId, isActive: true })),
    ]);
  };

  const changePoTemplate = async (poTemplateId, template) => {
    const obj = {
      poCreatedId: poCreatedId || pId,
      poTemplateId,
      devOrderId: devOrderId || dId,
      templateJsonSchema: template,
    };
    setOldState((preciousOld) => ({ ...preciousOld, ...purchaseOrderState }));
    const res = await dispatch(action.updatePOTemplate(obj, t));
    if (res) {
      callDevorderPoidApiFn();
      callUserIdBasedApiFn();
      callDevorderApiFn();
    }
  };

  useEffect(() => {
    if (
      oldStatedata?.templateJsonSchema &&
      !isEmpty(oldStatedata?.templateJsonSchema) &&
      !isEmpty(purchaseOrderDetails?.templateJsonSchema) &&
      purchaseOrderDetails?.templateJsonSchema
    ) {
      if (oldStatedata?.poTemplateId !== purchaseOrderDetails?.poTemplateId) {
        const oldtemplateData = cloneDeep(oldStatedata?.templateJsonSchema);
        const newtemplateData = cloneDeep(purchaseOrderDetails?.templateJsonSchema);
        const updatedTemplateJsonSchema = [...newtemplateData];

        newtemplateData?.forEach((newElement, newElementIndex) => {
          oldtemplateData?.forEach((oldElement) => {
            if (newElement?.key === oldElement?.key) {
              if (newElement?.key === 'Ratio_Pack') {
                if (newElement?.colorWay?._id === oldElement?.colorWay?._id) {
                  if (purchaseOrderDetails?.visible?.singular) {
                    updatedTemplateJsonSchema[newElementIndex].sigularPackedUnits = oldElement?.sigularPackedUnits;
                  }
                  if (purchaseOrderDetails?.visible?.multiple) {
                    updatedTemplateJsonSchema[newElementIndex].multiplePacks = oldElement?.multiplePacks;
                  }
                  if (purchaseOrderDetails?.visible?.multipleTotalPacks) {
                    updatedTemplateJsonSchema[newElementIndex].multipleTotalPacks = oldElement?.multipleTotalPacks;
                  }
                  if (purchaseOrderDetails?.visible?.ratio) {
                    updatedTemplateJsonSchema[newElementIndex].ratioPacks = oldElement?.ratioPacks;
                  }
                }
              } else {
                newElement?.columns?.forEach((newElementColumn, newElementColumnIndex) => {
                  oldElement?.columns?.forEach((oldElementColumn) => {
                    newElementColumn?.forEach((newEle, newEleIndex) => {
                      oldElementColumn?.forEach((oldEle) => {
                        if (newEle?.label === oldEle?.label && newEle?.enable) {
                          updatedTemplateJsonSchema[newElementIndex].columns[newElementColumnIndex][newEleIndex] = {
                            ...copyObjectWithoutKey(oldEle, 'enable'),
                            enable: newEle?.enable,
                          };
                        }
                      });
                    });
                  });
                });
              }
            }
          });
        });
        purchaseOrderDetails.templateJsonSchema = updatedTemplateJsonSchema;
        setNewTemplate(updatedTemplateJsonSchema);
      }
    } else {
      setNewTemplate([]);
    }
  }, [oldStatedata, purchaseOrderDetails]);

  const hasValue = (element) => {
    return element || null;
  };

  const conditions = (column, currentSupplier) => {
    return fromPreview || isPublicPoPage ? column?.value : column?.value && hasValue(currentSupplier);
  };

  const copyObjectWithoutKey = (obj, keyToExclude) => {
    const copiedObject = cloneDeep(obj);
    if (copiedObject.hasOwnProperty(keyToExclude)) {
      delete copiedObject[keyToExclude];
    }
    return copiedObject;
  };

  if (!isEmpty(purchaseOrderState?.templateJsonSchema)) {
    (purchaseOrderState?.templateJsonSchema ?? [])?.forEach((ele) => {
      if (ele?.key === 'A_F_Details') {
        (ele?.columns ?? [])?.forEach((columnEle) => {
          (columnEle ?? [])?.forEach((element) => {
            if (element?.id === '6' && element?.value) {
              purchaseOrderState.portOfLading = element?.value?.portOfLanding;
            }
          });
        });
      }
      if (ele?.key === 'Shipping_Details') {
        (ele?.columns ?? [])?.forEach((columnEle) => {
          (columnEle ?? [])?.forEach((element) => {
            if (element?.id === '12' && element?.value === 'No') {
              purchaseOrderState.costIncluded = 'No';
            }
          });
        });
      }
    });
  }

  const globalError = () => {
    const returnValue = [];
    let hasErr = false;
    purchaseOrderState?.templateJsonSchema?.forEach((element) => {
      element?.columns?.forEach((columnElements) => {
        columnElements?.forEach((colEle) => {
          if (colEle?.hasError && colEle?.hasError?.status === true) {
            returnValue.push(true);
            hasErr = true;
          }
        });
      });
    });
    if (hasErr) {
      toasterMsg('Please fill all the mandatory fields', 'danger');
    }
    return isEmpty(returnValue);
  };

  const disableConditions = () => {
    return (
      (purchaseOrderState?.status === 'canceled' && !forDuplication) ||
      (purchaseOrderState?.status === 'Cancelled' && !forDuplication) ||
      (purchaseOrderState?.status === 'Delivered' && !forDuplication) ||
      (purchaseOrderState?.status === 'Approve' && !forDuplication) ||
      (purchaseOrderState?.status === 'Confirmed' && !forDuplication) ||
      (purchaseOrderState?.status === 'Cancel Request' && !forDuplication) ||
      (purchaseOrderState?.status === 'Active' && !forDuplication) ||
      isProductArchived ||
      isSupplierLoggedIn
    );
  };

  const contextValue = {
    purchaseOrderState,
    setPurchaseOrderState,
    changePoTemplate,
    supplierAddress,
    initialSetting,
    callDevorderApiFn,
    callDevorderPoidApiFn,
    callUserIdBasedApiFn,
    setControlState,
    controlState,
    checkValidation,
    globalError,
    disableConditions,
    fromPreview,
    isPublicPoPage,
    previewData,
    isProductArchived,
    setOldState,
    oldInitialSetting,
    poAddEditAccess,
    poDeleteAccess,
    lengthEnabled,
  };

  return (
    <StateContext.Provider
      value={useMemo(() => {
        return { ...contextValue };
      }, [contextValue])}
    >
      {children}
    </StateContext.Provider>
  );
}

export function usePurchaseOrderState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the PurchaseOrderStateProvider');
  }
  return context;
}
